import React, { PureComponent } from 'react';
import { Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import StockLists from './components/StockLists';
import StocksDistribution from './components/StocksDistribution';

class Stocks extends PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        page: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }

  constructor() {
    super();
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  render() {
    const { match } = this.props;
    const { params } = match;
    const { page, itemID } = params;

    if (this.userdata == null || (this.userdata && this.userdata.type !== '4')) {
      return (<Redirect to="/login" />);
    }

    if (page === undefined) {
      return (<Redirect to="/stocks/list" />);
    }

    return (
      <Container>
        <Row>
          {page === 'distribution' ? <StocksDistribution itemID={itemID} /> : <StockLists />}
        </Row>
      </Container>
    );
  }
}

export default withTranslation('common')(Stocks);

// const Stocks = () => (
//   <Container>
//     <Row>
//         <StockProducts />
//     </Row>
//   </Container>
// );

// export default Stocks;
